const makePathArray = obj => {
  return flattenDeep(obj)
    .join(".")
    .replace(/\[/g, ".")
    .replace(/\]/g, "")
    .split(".");
};

const flattenDeep = (arr, newArr = []) => {
  if (!Array.isArray(arr)) {
    newArr.push(arr);
  } else {
    for (var i = 0; i < arr.length; i++) {
      flattenDeep(arr[i], newArr);
    }
  }
  return newArr;
};

const nestedParameter = (obj, path, def) => {
  if (!path) {
    return obj;
  }
  const pathObj = makePathArray(path);
  let val;
  try {
    val = pathObj.reduce((current, pathPart) => current[pathPart], obj);
  } catch (e) {}
  return typeof val !== "undefined" ? val : def;
};

export default nestedParameter;



// WEBPACK FOOTER //
// ./src/util/nested-parameter.js